import { tools } from './../helpers/tools';
import { settings } from './../settings';
import { ClaimsResponse } from '../api/models';
import ajax from '../api/ajax';

class Claims {
    constructor(domain) {
        this.url = {
            domain: domain,
            path: 'account/',
        };
    }
    
    init() {
        this.url.domain = settings.settings.acf[`claims_api_url`];
    }

    /**
     * Log out the user by destroying auth cookie.
     * @return {Promise<ClaimsResponse>} promise
     */
    destroy() {
        const self = this;

        return new Promise((resolve, reject) => {
            return ajax.get(self, `logout`, true).then((result) => {
                const response = new ClaimsResponse(result);

                resolve(response);
            }).catch((error) => {
                const response = new ClaimsResponse().failed(error);

                tools.handleError(self, response);

                reject(response);
            });
        });
    }
    
    /**
     * Get claim if user is authed.
     * @return {Promise<ClaimsResponse>} promise
     */
    get() {
        const self = this;
        
        return new Promise((resolve, reject) => {
            return ajax.get(self, `claims`, true).then((result) => {
                const response = new ClaimsResponse(result);

                if (result) {
                    response.result.personalNumberAsString = self.toPersonalNumber(response.result);
                    
                    resolve(response);
                } else {
                    reject(response);
                }
            }).catch((error) => {
                const response = new ClaimsResponse().failed(error);

                tools.handleError(self, response);

                reject(response);
            });
        });
    }

    toPersonalNumber(claims) {
        if (!claims) {
            return null;
        }
        
        return `${claims.year}${('0' + claims.month).slice(-2)}${('0' + claims.day).slice(-2)}-${claims.extraDigits}`
    }
}

export let claims = new Claims();


// WEBPACK FOOTER //
// ./scripts/booking/api/claims.js